/* eslint-disable class-methods-use-this */
import { apiredeciclo, http } from '@/plugins/axios';

class CheckoutProvider {
  constructor() {
    this.PATHNAME = 'api/certifications';
  }

  /**
   *
   * @param {String} plan - Códigos dos planos: `feather` (Plano Pequeno, antes chamado Peso Pena), `lightwt` (Plano Médio, antes chamado Peso Leve) e `average` (Plano Grande, antes chamado Peso Médio);
   * @param {Object} [params] - Objeto contendo parametros que serão utilizados na requisição;
   *
   * @param {String} [params.promocode] - "" | "RECICLA10" | qualquer outro código promocional que deva ser aplicado automaticamente
   */
  getPlans(PLAN_CODE_NAME, params) {
    return apiredeciclo.get(`${this.PATHNAME}/plans/${PLAN_CODE_NAME}/prices`, {
      params,
    });
  }

  postRegisterLead(data) {
    return apiredeciclo.post(`${this.PATHNAME}/lead`, data, {
      timeout: 30000,
    });
  }

  searchCNPJ(cnpj) {
    return apiredeciclo.get(`${this.PATHNAME}/corporations/lookup/${cnpj}`);
  }

  postNewClient(client) {
    return apiredeciclo.post(`${this.PATHNAME}/signup`, client, {
      timeout: 30000,
    });
  }

  /**
   * API que realiza a contratação de um plano para o cliente
   *
   * @param {Object} params - Objeto contendo parametros que serão utilizados na requisição;
   *
   * @param {Number} params.liability_percentage - Porcentagem de compensação (22, 50, 100 ou 200);
   * @param {Number} params.liability_year - Ano da compensação (costuma ser ano atual menos 1)
   * @param {Number} params.plan_identifier - Código identificador do plano ("feather", "lightwt" ou "average"; se for a fatura anual, adiciona o sufixo "-yearly")
   * @param {String} params.plan_period - Como o plano será cobrado, mensal ou anualmente ("month" ou "year")
   * @param {Array[]} params.pricing_items - Quais são os itens (composição das embalagens) na contratação
   * @param {String} params.pricing_items[].material_name - Código do material contratado ("metal", "paper", "plastic" ou "glass")
   * @param {Number} params.pricing_items[].material_percent - Porcentagem da massa contratada do material (número inteiro entre 1 e 100; a soma de todos deve ser 100)
   * @param {String} params.organization_guid - Guid da organização
   *
   * Atributos Opcionais
   * @param {String} [params.promocode] - Código de cupom inserido na contratação
   * @param {String} [params.referrer] - Código identificando se o cliente chegou por referência externa
   *
   * Atributos obrigatórios caso esteja pagando por cartão de crédito
   * @param {String} [params.payment_token] - Token providenciado pelo iugu ao transmitir os dados do cartão
   * @param {String} [params.cardholder_taxid] - CPF ou CNPJ do titular do cartão
   * @param {String} [params.cardholder_name] - Nome do titular do cartão
   * @param {String} [params.contact_email] - E-mail do titular do cartão
   * @param {String} [params.address_zipcode] - CEP no endereço de cobrança do cartão
   * @param {String} [params.address_street_name] - Logradouro no endereço de cobrança do cartão
   * @param {String} [params.address_street_number] - Numeração no endereço de cobrança do cartão
   * @param {String} [params.address_city] - Cidade no endereço de cobrança do cartão
   * @param {String} [params.address_state] - Estado (UF) no endereço de cobrança do cartão
   *
   * Atributos opcionais caso esteja pagando por cartão de crédito
   * @param {String} [params.address_additional_info] - Complemento no endereço de cobrança do cartão
   *
   */
  postSubscribeCustomer(params) {
    return apiredeciclo.post(`${this.PATHNAME}/subscribe`, params, {
      timeout: 30000,
    });
  }

  /**
   * Retorna uma lista contendo todas as associações
   *
   */
  associations(params) {
    return apiredeciclo.get(
      `${this.PATHNAME}/associations`,
      { params: { ...params, top: -1, skip: 0 } },
      {
        timeout: 30000,
      },
    );
  }

  saveLead(params) {
    return http.post(`http://localhost:8181/lead`, params, {
      timeout: 30000,
    });
  }

  /**
   * Retorna uma lista contendo os portes de empresas
   *
   */
  organizationSizes() {
    return apiredeciclo.get(
      `${this.PATHNAME}/sizes/organizations`,
      { params: { top: -1, skip: 0 } },
      {
        timeout: 30000,
      },
    );
  }
  /**
   * Retorna uma lista contendo os estados brasileiros - Fonte: ibge.gov.br
   *
   */

  states() {
    return apiredeciclo.get(
      'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome',
    );
  }
  /**
   * Retorna uma lista contendo as cidades do estado selecionado - Fonte: ibge.gov.br
   *
   */

  citiesByState(uf) {
    return apiredeciclo.get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`,
    );
  }
}

export default new CheckoutProvider();
